var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialIconLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10zm7.567-2.718H5.3v6.81h2.266v-6.81zm.15-2.106C7.7 4.51 7.223 4 6.448 4s-1.282.509-1.282 1.176c0 .654.492 1.177 1.252 1.177h.015c.79 0 1.282-.523 1.282-1.177zm8.023 5.011c0-2.091-1.118-3.064-2.61-3.064-1.203 0-1.741.66-2.042 1.124v-.964H8.82c.03.639 0 6.809 0 6.809h2.267v-3.803c0-.204.014-.407.074-.552.164-.407.537-.828 1.163-.828.82 0 1.149.625 1.149 1.54v3.642h2.266v-3.904z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default SvgSocialIconLinkedin;